/**
 * Downloads the specified text content as a file with the given name.
 *
 * @param {string} name - The name of the file to be downloaded.
 * @param {string} content - The text content to be saved in the file.
 *
 * @return {void}
 */
export default function downloadText(name: string, content: string): void {
  const link = document.createElement("a");
  const blob = new Blob([content], {
    type: "text/json",
  });
  link.download = name;
  link.href = window.URL.createObjectURL(blob);
  link.dataset.downloadurl = ["text/json", link.download, link.href].join(":");

  const evt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });

  link.dispatchEvent(evt);
  link.remove();
}
